import ApiClient from '../ApiClient';

class EvolutionChannel extends ApiClient {
  constructor() {
    super('channels/evolution_channel', { accountScoped: true });
  }

  create(params) {
    return super.create({
      evolution_channel: params,
    });
  }
}

export default new EvolutionChannel();
